// extracted by mini-css-extract-plugin
export default {"canvas":"uCATaq","hidden":"NhkNRb","visuallyHidden":"o0r5jD"};